import React, { useEffect, useState, useContext } from 'react'
import { useParams } from 'react-router-dom'

import { getUserScoreLevelCounters } from '../../api'

import ScoreLevelCounters from './ScoreLevelCounters'
import ErrorMessage from '../../ErrorMessage'
import Loader from '../../Loader'

import { Context } from '../../Context'

const ScoreLevelCountersLoader = () => {
	const { guid } = useParams()
	const { game, player } = useContext(Context)
	const [errorMsg, setErrorMsg] = useState(null)
	const [loading, setLoading] = useState(false)
	const [data, setData] = useState(null)
	// const isPlayer = !!player

	useEffect(() => {
		// setPlayer(null)
		setLoading(true)
		getUserScoreLevelCounters(game, guid, (err, data) => {
			setLoading(false)
			if (err) return setErrorMsg(err)
			// setPlayer(player)
			setData(data)
		})
		// return () => setPlayer(null)
	}, [game, guid])

	if (loading) return <Loader />
	if (data) return <ScoreLevelCounters guid={guid} elo={player?.elo} levelInfo={data.levelInfo} scores={data.scores} counters={data.counters} trophies={data.trophies}/>
	if (errorMsg) return <ErrorMessage title="Error" body={errorMsg} />
	return null
}

export default ScoreLevelCountersLoader
